<template>
    <div class="mail-home-icon">
        <i class="fa-solid fa-paper-plane"></i>
    </div>
</template>

<script>
export default {
    props: {
        context: {
            type: Object
        }
    }
}
</script>

<style scoped>
.mail-home-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    border-radius: 18px;
    background: linear-gradient(135deg, #6366f1, #8b5cf6);
    font-size: 24px;
    color: #fff;
}
</style>
